3<script>
  import acessosServico from '../../servico';
  import pagamentoServico from '../../../pagamento/servico';
  import radio from '~componentes/Radio.vue';
  import formatarData from '~js/formatar-data';
  import converterObjetoFormData from '~js/converter-objeto-formdata';
  import Vue from 'vue';
  import converterMoeda from '~js/converter-moeda';
  import linguagens from '~js/linguagens';
  import solCursoEventoDoacaoTranslate from '~js/solCursoEventoDoacaoTranslate';

  import DadosPfPj from '../compartilhado/AcessosInscricaoFormPFPJ.vue';
  import DadosEstrangeiro from '../compartilhado/AcessosInscricaoFormEstrangeiro.vue';
  import ResumoInscricao from '../compartilhado/AcessosInscricaoResumo.vue';
  import ResumoInscricaoEstrangeiro from '../compartilhado/AcessosInscricaoResumoEstrangeiro.vue';
  import ResumoInscricaoCartao from '../compartilhado/AcessosInscricaoCartaoCredito.vue';
  import AcessosInscricaoArquivos from '../compartilhado/AcessosInscricaoArquivos.vue';

  export default {
    components: { radio, DadosPfPj, DadosEstrangeiro, ResumoInscricao, ResumoInscricaoCartao, ResumoInscricaoEstrangeiro, AcessosInscricaoArquivos },
    props: {
      acessoObjeto: {
        type: Object,
        required: true
      },
      idCript: {
        type: String,
        required: true,
      },
      idInscricaoDiretaCript: {
        type: String,
        required: false,
        default:'',
      },
    },
    data() {
      return {
        linguagens: linguagens,
        linguagensDisponiveis: [],
        linguagemSelecionada: 'pt-Br',
        solCursoEventoDoacaoTranslate: solCursoEventoDoacaoTranslate,
        labelsLinguagemSelecionada: {},
        labelsDadosLinguagemSelecionada: {
            "descricao": "",
            "resumo": "",
        },

        configuracao: this.$storage.configuracao(),
        imagemCover: '',
        rotaAnterior: '',
        rotaPrincipal: '',
        rotaInscricao: '',
        tituloInscricao: '',
        tituloSite: '',

        cursosEventosObj: {},
        tipoDocumento: 'CPF',
        mostraResumoInscricao: false,
        mostrarCartao: false,
        mostrarMeioPagamento: false,
        idInscricaoCript: '',

        doacao: false,

        documento: '',
        mostrarFormulario: false,
        inscricao: this.camposInscricao(),
        arquivos: [],
        carregando: false,
        pagamento: this.carregarPagamento(),

        cadastroCompleto: true,
        utilizarArquivo: false,
        mostrarMeioPagamentoBoleto: false,
        mostrarMeioPagamentoCartao: false,
        mostrarPagSeguroCheckout: false,

        mostrarMeioPagamentoBoletoGetNet: false,
        mostrarMeioPagamentoCreditoGetNet: false,
        mostrarMeioPagamentoDebitoGetNet: false,
        mostrarMeioPagamentoCreditoIntGetNet: false,
        mostrarMeioPagamentoPayPalEstrangeiro: false,        
        mostrarMeioPagamentoPix: false,

        mostrarMeioPagamento1: true,
        mostrarMeioPagamento2: true,
        mostrarMeioPagamento3: true,

        meioPagamento1Titulo: '',
        meioPagamento2Titulo: '',
        meioPagamento3Titulo: '',

        meioPagamento1Descricao: '',
        meioPagamento2Descricao: '',
        meioPagamento3Descricao: '',

        mostrarMeioPagamentoEstrangeiro1: false,
        mostrarMeioPagamentoEstrangeiro2: false,
        mostrarMeioPagamentoEstrangeiro3: false,

        meioPagamentoEstrangeiro1Titulo: '',
        meioPagamentoEstrangeiro2Titulo: '',
        meioPagamentoEstrangeiro3Titulo: '',

        meioPagamentoEstrangeiro1Descricao: '',
        meioPagamentoEstrangeiro2Descricao: '',
        meioPagamentoEstrangeiro3Descricao: '',

        meioPagamentoDescricao: '',

        mensagemConclusao : '',
        urlDirecionamento: '',

        mostraDivMeioPagamento: true,
        mostraMensagemPagamentoPagSeguro: false,

        mostrarEstrangeiro: false,
        estrangeiro: false,

        mostraMensagemPagamentoPix: false,
        copiaColaPix: "",
        imgQRCodePix: "",
        tmrPix: null,
        segundosPix: 300,

        mostrarMensagemPagoStatus: 0,
      }
    },
    methods: {
      setarLinguagemSelecionada(simbolo){
        if (this.solCursoEventoDoacaoTranslate.filter(l => l.simbolo == simbolo).length == 0)
        {
           simbolo = 'pt-Br'
        }         
          
        this.linguagemSelecionada = simbolo;
        this.labelsLinguagemSelecionada = this.solCursoEventoDoacaoTranslate.filter(l => l.simbolo == simbolo)[0];
        this.inscricao.linguagemSelecionada = simbolo;

        if (this.acessoObjeto.doacao){
            this.labelsDadosLinguagemSelecionada = this.acessoObjeto.doacao.doacaoTraducoes.filter(l => l.idLinguagem == this.labelsLinguagemSelecionada.id)[0];
        }

        if (this.acessoObjeto.turma){
            this.labelsDadosLinguagemSelecionada = this.acessoObjeto.turma.turmaTraducoes.filter(l => l.idLinguagem == this.labelsLinguagemSelecionada.id)[0];
        } 

        this.configuraTipo(true);
        this.setaMeiosPagamento();
      },
      mostraLinguagens(){
        this.linguagensDisponiveis = [];

        this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'pt-Br')[0])

        if (this.acessoObjeto.turma){
            if (this.acessoObjeto.turma.traduzirIngles)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'en')[0])

            if (this.acessoObjeto.turma.traduzirEspanhol)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'es')[0])

            if (this.acessoObjeto.turma.traduzirFrances)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'fr')[0])

            if (this.acessoObjeto.turma.traduzirItaliano)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'it')[0])
        }

        if (this.acessoObjeto.doacao){
            if (this.acessoObjeto.doacao.traduzirIngles)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'en')[0])

            if (this.acessoObjeto.doacao.traduzirEspanhol)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'es')[0])

            if (this.acessoObjeto.doacao.traduzirFrances)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'fr')[0])

            if (this.acessoObjeto.doacao.traduzirItaliano)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'it')[0])
        }
      },
      copiarCopiaColaPix() {
        var txt = document.getElementById("copiaColaPix");
        txt.select();
        document.execCommand('copy');

        toastr.success(this.labelCopiaColaPIX);
      },
      startTimerPix() {
        this.segundosPix = 300;
        this.tmrPix = setInterval(this.setTimerPix, 1000);
      },
      setTimerPix() {
        this.segundosPix--;

        var date = new Date(null);
        date.setSeconds(this.segundosPix);
        let timerPix = date.toISOString().substr(11, 8);
        var segundos = date.getSeconds() + date.getMinutes() * 60;

        if ((segundos % 30) == 0) { 
          pagamentoServico
            .verificarPagamentoPix(this.pagamento)
            .then(retorno => {
              this.stopTimerPix();
              this.mostraMensagemPagamentoPix = false;

              var pix = JSON.parse(retorno.bodyText);
              this.$set(this.inscricao, 'lancamentoInscricoes', [{ "lancamento": { "data": 0 } }]);
              this.inscricao.lancamentoInscricoes[0].lancamento.data = pix.dataPagamento;
            });
        }

        $("#tempo-pix").text(timerPix);
      },
      stopTimerPix() {
        clearInterval(this.tmrPix);
        $('#pagaPix').button('reset');
      },
      validarDadosDoacao(valido) {
        if (!valido) {
          this.$swal(
            '',
            this.labelsErroCamposObrigatorios,
            'info'
          );
          throw new Error('validacao');
        }

        if (!this.doacao) return true;

        let msgErro = "";

        const valorMinimo = this.$options.filters.formatarNumero(this.acessoObjeto.doacao.valorMinimo, true);
        const valorMaximo = this.$options.filters.formatarNumero(this.acessoObjeto.doacao.valorMaximo, true);
        const valor = this.$options.filters.formatarNumero(this.inscricao.valor, true);



        if ((valorMinimo > 0) || (valorMaximo > 0)) {

          // Entre dois valores
          if ((valorMinimo > 0) && (valorMaximo > 0)) {
            if ((!msgErro) && (valor > 0) && ((valor < valorMinimo) || (valor > valorMaximo))) {
              msgErro = this.labelsValorEntre + this.$options.filters.formatarNumero(valorMinimo) +
                ' - ' + this.$options.filters.formatarNumero(valorMaximo);
            }
          }
          else {
            // Entre valor 1
            if (valorMinimo > 0) {
              if ((!msgErro) && (valor < valorMinimo)) {
                msgErro = this.labelsValorMaiorIgual + this.$options.filters.formatarNumero(valorMinimo)
              }
            }
            else {
              // Entre valor 2
              if ((!msgErro) && (valor > valorMaximo)) {
                msgErro = this.labelsValorMenorIgual + this.$options.filters.formatarNumero(valorMaximo)
              }
            }
          }
        }

        if (msgErro) {
          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
      validarQuestionarios(valido) {
        if (!valido) {
            if (this.estrangeiro) {
                this.$swal(
                    '',
                    this.labelsErroCamposObrigatorios,
                    'info'
                    ); 
                throw new Error('validacao');
            }    
            else
                throw new Error("validacao com erro");
        }

        if (!this.inscricao.questionarios) return true;

        if (this.inscricao.questionarios.length == 0) return true;

        let msgErro = "";
        let validou = true;

        for (var i = 0; i < this.inscricao.questionarios.length; i++) {
          if (this.inscricao.questionarios[i].obrigatorio) {
            if (this.inscricao.questionarios[i].tipoCampoSimNao) {
              if (!((this.inscricao.questionarios[i].selecionado == 'true') || (this.inscricao.questionarios[i].selecionado == 'false'))) {
                validou = false;
                break;
              }
            }

            if (this.inscricao.questionarios[i].tipoCampoResposta) {
              if (!this.inscricao.questionarios[i].campoResposta) {
                validou = false;
                break;
              }
            }

            if (this.inscricao.questionarios[i].tipoCampoResposta) {
              if (!this.inscricao.questionarios[i].campoResposta) {
                validou = false;
                break;
              }
            }
          }
        }

        if (!validou) msgErro = this.labelsPerguntasObrigatorias;

        if (msgErro) {
          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
      camposInscricao() {
        return {
          idSolicitacao: this.idCript,
          documento: '',
          nome: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          uf: '',
          cep: '',
          telefone: '',
          celular: '',
          email: '',
          dataNascimento: '',
          identidade: '',
          tipo: 0,
          valor: this.formataValorInscricao(this.retornaValor()),
          faixaValores: '',
          utilizarArquivo: false,
          arquivosAprovados: false,
          idTurmaFaixaValores: 0,
          mensagemAnexoArquivos: '',
          anexoObrigatorio: false,
          quantidadeMinimaArquivos: 1,
          quantidadeMaximaArquivos: 0,
          questionarios: [],
          linguagemSelecionada: 'pt-Br'
        };
      },
      carregarPagamento() {
        return {
          nomeCartao: '',
          numeroCartao: '',
          cvv: '',
          vencimentoCartao: '',
          documento: '',
          tipoDocumentoCartao: 'CPF',
          dataNascimentoCartaoCredito: '',
          telefoneCartaoCredito: '',
          bandeira: '',
          token: '',
          idLancamento: '',
          hash: '',
          documentoInscricao: '',
        }
      },
      retornaValor() {
        if (this.acessoObjeto.turma) {
          return this.acessoObjeto.turma.valorInscricao;
        }

        return null;
      },
      formataValorInscricao(valor) {
        return converterMoeda.paraReal(valor);
      },
      configuraTipo(mudandoLinguagem) {
        switch (this.$route.name) {
          case 'acessos.cursos-inscricao':
          case 'acessos.cursos-inscricao-linkdireto':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/curso_cover.png';
            this.rotaAnterior = 'acessos.cursos-detalhamento';
            this.rotaPrincipal = 'acessos.cursos';
            this.tituloInscricao = this.labelsInscricao;
            this.tituloSite = this.labelsTituloSiteCurso;
            break;
          case 'acessos.eventos-inscricao':
          case 'acessos.eventos-inscricao-linkdireto':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/evento_cover.png';
            this.rotaAnterior = 'acessos.eventos-detalhamento';
            this.rotaPrincipal = 'acessos.eventos';
            this.tituloInscricao = this.labelsInscricao;
            this.tituloSite = this.labelsTituloSiteEvento;
            break;
          case 'acessos.doacoes-doar':
          case 'acessos.doacoes-doar-recorrente':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/doacao_cover.png';
            this.rotaAnterior = 'acessos.doacoes-detalhamento';
            this.rotaPrincipal = 'acessos.doacoes';
            this.tituloInscricao = this.labelsDoacao;
            this.doacao = true;
            this.tituloSite = this.labelsTituloSiteDoacao;
            break;
          case 'acessos.licitacoes-detalhe':            
            this.rotaAnterior = 'acessos.licitacoes-detalhamento';
            this.rotaPrincipal = 'acessos.licitacoes';
            this.tituloInscricao = 'licitação';
            this.licitacao = true;
            break;
          default:
            this.$router.push('/acessos');
        }
      },
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      setaCadastroCompleto() {
        switch (this.$route.name) {
          case 'acessos.cursos-inscricao':
          case 'acessos.cursos-inscricao-linkdireto':
          case 'acessos.eventos-inscricao':
          case 'acessos.eventos-inscricao-linkdireto':
            this.cadastroCompleto = this.acessoObjeto.turma.cadastroCompleto;
            break;
          case 'acessos.doacoes-doar':
          case 'acessos.doacoes-doar-recorrente':
            this.cadastroCompleto = this.acessoObjeto.doacao.cadastroCompleto;
            break;
        }
      },
      setaMeiosPagamento() {
        switch (this.$route.name) {
          case 'acessos.cursos-inscricao':
          case 'acessos.cursos-inscricao-linkdireto':
          case 'acessos.eventos-inscricao':
          case 'acessos.eventos-inscricao-linkdireto':
            this.mostrarMeioPagamentoBoleto = this.acessoObjeto.turma.boleto;
            this.mostrarMeioPagamentoCartao = this.acessoObjeto.turma.cartaoCredito;
            this.mostrarPagSeguroCheckout = this.acessoObjeto.turma.pagSeguroCheckout;

            this.mostrarMeioPagamentoBoletoGetNet = this.acessoObjeto.turma.getNetBoleto;
            this.mostrarMeioPagamentoCreditoGetNet = this.acessoObjeto.turma.getNetCredito;
            this.mostrarMeioPagamentoDebitoGetNet = this.acessoObjeto.turma.getNetDebito;
            this.mostrarMeioPagamentoCreditoIntGetNet = this.acessoObjeto.turma.getNetCreditoEstrangeiro;
            this.mostrarMeioPagamentoPayPalEstrangeiro = this.acessoObjeto.turma.payPalEstrangeiro;
            this.mostrarMeioPagamentoPix = this.acessoObjeto.turma.pixSantander;

            this.mostrarMeioPagamento1 = this.acessoObjeto.turma.meioPagamento1;
            this.mostrarMeioPagamento2 = this.acessoObjeto.turma.meioPagamento2;
            this.mostrarMeioPagamento3 = this.acessoObjeto.turma.meioPagamento3;

            this.meioPagamento1Titulo = this.acessoObjeto.turma.meioPagamento1Titulo;
            this.meioPagamento2Titulo = this.acessoObjeto.turma.meioPagamento2Titulo;
            this.meioPagamento3Titulo = this.acessoObjeto.turma.meioPagamento3Titulo;

            this.meioPagamento1Descricao = this.acessoObjeto.turma.meioPagamento1Descricao;
            this.meioPagamento2Descricao = this.acessoObjeto.turma.meioPagamento2Descricao;
            this.meioPagamento3Descricao = this.acessoObjeto.turma.meioPagamento3Descricao;

            this.mostrarMeioPagamentoEstrangeiro1 = this.acessoObjeto.turma.meioPagamentoEstrangeiro1;
            this.mostrarMeioPagamentoEstrangeiro2 = this.acessoObjeto.turma.meioPagamentoEstrangeiro2;
            this.mostrarMeioPagamentoEstrangeiro3 = this.acessoObjeto.turma.meioPagamentoEstrangeiro3;

            this.meioPagamentoEstrangeiro1Titulo = this.acessoObjeto.turma.meioPagamentoEstrangeiro1Titulo;
            this.meioPagamentoEstrangeiro2Titulo = this.acessoObjeto.turma.meioPagamentoEstrangeiro2Titulo;
            this.meioPagamentoEstrangeiro3Titulo = this.acessoObjeto.turma.meioPagamentoEstrangeiro3Titulo;

            this.meioPagamentoEstrangeiro1Descricao = this.acessoObjeto.turma.meioPagamentoEstrangeiro1Descricao;
            this.meioPagamentoEstrangeiro2Descricao = this.acessoObjeto.turma.meioPagamentoEstrangeiro2Descricao;
            this.meioPagamentoEstrangeiro3Descricao = this.acessoObjeto.turma.meioPagamentoEstrangeiro3Descricao;

            if (this.labelsDadosLinguagemSelecionada.mensagemFinalSalvar)
              this.mensagemConclusao = this.labelsDadosLinguagemSelecionada.mensagemFinalSalvar;
            this.urlDirecionamento = this.acessoObjeto.turma.urlDirecionamento; 
            this.mostrarEstrangeiro = this.acessoObjeto.turma.permitirEstrangeiro; 
            if (this.acessoObjeto.turma.urlImagemPerfil)
              this.imagemCover = this.acessoObjeto.turma.urlImagemPerfil;
            this.utilizarArquivo = this.acessoObjeto.turma.utilizarArquivo;
            break;
          case 'acessos.doacoes-doar':
          case 'acessos.doacoes-doar-recorrente':
            this.mostrarMeioPagamentoBoleto = this.acessoObjeto.doacao.boleto;
            this.mostrarMeioPagamentoCartao = this.acessoObjeto.doacao.cartaoCredito;
            this.mostrarPagSeguroCheckout = this.acessoObjeto.doacao.pagSeguroCheckout;

            this.mostrarMeioPagamentoBoletoGetNet = this.acessoObjeto.doacao.getNetBoleto;
            this.mostrarMeioPagamentoCreditoGetNet = this.acessoObjeto.doacao.getNetCredito;
            this.mostrarMeioPagamentoDebitoGetNet = this.acessoObjeto.doacao.getNetDebito;
            this.mostrarMeioPagamentoCreditoIntGetNet = this.acessoObjeto.doacao.getNetCreditoEstrangeiro;
            this.mostrarMeioPagamentoPayPalEstrangeiro = this.acessoObjeto.doacao.payPalEstrangeiro;
            this.mostrarMeioPagamentoPix = this.acessoObjeto.doacao.pixSantander;

            this.mostrarMeioPagamento1 = this.acessoObjeto.doacao.meioPagamento1;
            this.mostrarMeioPagamento2 = this.acessoObjeto.doacao.meioPagamento2;
            this.mostrarMeioPagamento3 = this.acessoObjeto.doacao.meioPagamento3;

            this.meioPagamento1Titulo = this.acessoObjeto.doacao.meioPagamento1Titulo;
            this.meioPagamento2Titulo = this.acessoObjeto.doacao.meioPagamento2Titulo;
            this.meioPagamento3Titulo = this.acessoObjeto.doacao.meioPagamento3Titulo;

            this.meioPagamento1Descricao = this.acessoObjeto.doacao.meioPagamento1Descricao;
            this.meioPagamento2Descricao = this.acessoObjeto.doacao.meioPagamento2Descricao;
            this.meioPagamento3Descricao = this.acessoObjeto.doacao.meioPagamento3Descricao;

            this.mostrarMeioPagamentoEstrangeiro1 = this.acessoObjeto.doacao.meioPagamentoEstrangeiro1;
            this.mostrarMeioPagamentoEstrangeiro2 = this.acessoObjeto.doacao.meioPagamentoEstrangeiro2;
            this.mostrarMeioPagamentoEstrangeiro3 = this.acessoObjeto.doacao.meioPagamentoEstrangeiro3;

            this.meioPagamentoEstrangeiro1Titulo = this.acessoObjeto.doacao.meioPagamentoEstrangeiro1Titulo;
            this.meioPagamentoEstrangeiro2Titulo = this.acessoObjeto.doacao.meioPagamentoEstrangeiro2Titulo;
            this.meioPagamentoEstrangeiro3Titulo = this.acessoObjeto.doacao.meioPagamentoEstrangeiro3Titulo;

            this.meioPagamentoEstrangeiro1Descricao = this.acessoObjeto.doacao.meioPagamentoEstrangeiro1Descricao;
            this.meioPagamentoEstrangeiro2Descricao = this.acessoObjeto.doacao.meioPagamentoEstrangeiro2Descricao;
            this.meioPagamentoEstrangeiro3Descricao = this.acessoObjeto.doacao.meioPagamentoEstrangeiro3Descricao;

            if (this.labelsDadosLinguagemSelecionada.mensagemFinalSalvar)
              this.mensagemConclusao = this.labelsDadosLinguagemSelecionada.mensagemFinalSalvar
            this.urlDirecionamento = this.acessoObjeto.doacao.urlDirecionamento;
            if (this.acessoObjeto.doacao.urlImagemPerfil)
              this.imagemCover = this.acessoObjeto.doacao.urlImagemPerfil;

            this.mostrarEstrangeiro = this.acessoObjeto.doacao.permitirEstrangeiro;
            break;
        }
      },
      limparDocumento() {
        this.documento = '';

        this.estrangeiro = (this.tipoDocumento == 'Passaporte');
      },
      validarBeneficiario() {
        if (this.estrangeiro) {
          this.$validator
            .validate('emailerro', this.documento)
            .then(valido => {
              if (!valido) throw new Error("validacao");
            })
            .then(this.buscarBeneficiario)
            .catch(erro => {
              this.$mensagemErro(erro);
            });          
        } else {
          this.$validator
            .validate('documento', this.documento)
            .then(valido => {
              if (!valido) throw new Error("validacao");
            })
            .then(this.buscarBeneficiario)
            .catch(erro => {
              this.$mensagemErro(erro);
            });
        }        
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.configuraTipo();
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');

        return acessosServico
          .busca(this.documento, this.idCript, this.estrangeiro, this.idInscricaoDiretaCript)
          .then(retorno => {
            $('#avancar').button('reset');
           
              if (retorno.status === 202) {
                  this.inscricao.documento = retorno.pessoa.cpfCnpj;
                  this.inscricao.nome = retorno.pessoa.nomePessoaFisicaJuridica.substring(0, 100);
                  this.$set(this, 'mostrarFormulario', true);
                  this.$set(this, 'mostraResumoInscricao', false);

              } else if (retorno.status === 307) {
                  switch (this.$route.name) {
                      case 'acessos.cursos-inscricao':
                      case 'acessos.cursos-inscricao-linkdireto':
                        this.$router.push({ name: 'acessos.cursos' });
                        break;
                      case 'acessos.eventos-inscricao':
                      case 'acessos.eventos-inscricao-linkdireto':
                        this.$router.push({ name: 'acessos.eventos' });
                        break;
                      case 'acessos.doacoes-doar':
                      case 'acessos.doacoes-doar-recorrente':
                        this.$router.push({ name: 'acessos.doacoes' });
                        break;
                  }                  
              } else {
              retorno.inscricao.dataNascimento = this.$options.filters.formatarNumeroEmData(retorno.inscricao.dataNascimento);
              this.$set(this, 'inscricao', retorno.inscricao);
              this.$set(this, 'mostraResumoInscricao', true);
              this.$set(this, 'mostrarFormulario', false);
              this.$set(this.pagamento, 'idLancamento', retorno.inscricao.lancamentoInscricoes[0].idLancamento);
              this.pagamento.documentoInscricao = retorno.inscricao.documento;
              this.idInscricaoCript = retorno.inscricao.idInscricaoCript;
              this.setarLinguagemSelecionada(retorno.inscricao.linguagemSelecionada); 

              switch (retorno.inscricao.tipo) {
                  case 1:
                    this.tipoDocumento = 'CPF'
                    break;
                  case 2:
                    this.tipoDocumento = 'CNPJ'
                    break;
                  case 3:
                    this.tipoDocumento = 'Passaporte'
                    break;
                  default:
                    return 'CPF';
                    break;
                } 
                
              this.estrangeiro = (this.tipoDocumento == 'Passaporte');
              this.setaMeiosPagamento();
            }
          })
          .then(() => acessosServico.arquivos(this.idInscricaoCript, this.utilizarArquivamentoEdicao))
          .then(arquivos => {
            this.arquivos = arquivos;
            $('#alterar').button('reset');

            if ((this.$refs.acessosInscricaoArquivos) && (!this.inscricao.arquivosAprovados))
              this.$refs.acessosInscricaoArquivos.limparArquivos();
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.inscricao.documento = this.documento;

            this.$set(this, 'mostrarFormulario', true);
            this.$set(this, 'mostraResumoInscricao', false);
          });
      },
      async validarArquivos() {
        if (!this.$refs.acessosInscricaoArquivos)
          return true;

        var existeArquivo = false;

        for (var i = 0; i < this.$refs.acessosInscricaoArquivos.arquivosInterno.length; i++) {
          if (this.$refs.acessosInscricaoArquivos.arquivosInterno[i]) {
            existeArquivo = true;
            break;
          }
        }

        if (!existeArquivo) {
          this.$swal(
            '',
            this.labelsAnexarPeloMenosUmArquivo,
            'info'
          );

          $('#alterar').button('reset');
          throw new Error('validacao');
        }

        return existeArquivo;
      },
      async validarArquivosObrigatorio() {
        if (!this.$refs.acessosInscricaoArquivos)
          return true;

        if (!this.inscricao.anexoObrigatorio)
          return true;

        var quantidadeArquivo = 0;
        var quantidadeMinimaArquivos = (this.inscricao.anexoObrigatorio <= 0) ? 1 : this.inscricao.quantidadeMinimaArquivos;
        var quantidadeMaximaArquivos = (this.inscricao.anexoObrigatorio <= 0) ? 0 : this.inscricao.quantidadeMaximaArquivos;

        for (var i = 0; i < this.$refs.acessosInscricaoArquivos.arquivosInterno.length; i++) {
          if (this.$refs.acessosInscricaoArquivos.arquivosInterno[i]) {
            quantidadeArquivo += 1;
          }
        }

        if (quantidadeArquivo < quantidadeMinimaArquivos) {
          this.$swal(
            '',
            this.labelsNecessarioAnexarPeloMenos + quantidadeMinimaArquivos +  this.labelsArquivos,
            'info'
          );

          $('#salvar').button('reset');
          throw new Error('validacao');
        }

        if ((quantidadeArquivo > quantidadeMaximaArquivos) && (quantidadeMaximaArquivos > 0)) {
          this.$swal(
            '',
            this.labelsPermitidoAnexarMax + quantidadeMaximaArquivos + this.labelsArquivos,
            'info'
          );

          $('#salvar').button('reset');
          throw new Error('validacao');
        }

        return true;
      },
      alterar() {
        $('#alterar').button('loading');

        this.validarArquivosObrigatorio()
          .then(this.enviar)
          .then(retorno => {
            this.$swal("", `${this.tituloInscricao} ${this.labelsSalvaSucesso}`, "success");
            this.idInscricaoCript = retorno.idCript;
          })
          .then(this.enviarArquivos)
          .then(() => acessosServico.arquivos(this.idInscricaoCript, this.utilizarArquivamento))
          .then(arquivos => {
            this.arquivos = arquivos;
            $('#alterar').button('reset');
            this.$refs.acessosInscricaoArquivos.limparArquivos();
          })
          .catch(erro => {
            $('#alterar').button('reset');
            this.$mensagemErro(erro, `Erro ao atualizar a ${this.tituloInscricao}.`);
          });
      },
      salvarInscricaoPessoa() {
        this.$refs.dadosPfPj
          .validar()
          .then(valido => {

            return valido;
          })
          .then(this.validarDadosDoacao)
          .then(this.validarQuestionarios)
          .then(this.validarArquivosObrigatorio)
          .then(this.enviar)
          .then(retorno => {

            this.$swal("", this.mensagemConclusao , "success");

            this.mostrarFormulario = false;
            this.mostraResumoInscricao = true;
            this.$set(this.pagamento, 'idLancamento', retorno.id);
            this.idInscricaoCript = retorno.idCript;
          })
          .then(this.enviarArquivos)
          .then(() => acessosServico.arquivos(this.idInscricaoCript, this.utilizarArquivamento))
          .then(arquivos => {
            this.arquivos = arquivos;

            if (this.$refs.acessosInscricaoArquivos)
              this.$refs.acessosInscricaoArquivos.limparArquivos();
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, `${this.labelsErroSalvar} ${this.tituloInscricao}.`);
          });
      },
      salvarInscricaoPessoaEstrangeira() {
        this.$refs.dadosEstrangeiro
          .validar()
          .then(valido => {

            return valido;
          })
          .then(this.validarDadosDoacao)
          .then(this.validarQuestionarios)
          .then(this.validarArquivosObrigatorio)
          .then(this.enviar)
          .then(retorno => {

            this.$swal("", this.mensagemConclusao, "success");

            this.mostrarFormulario = false;
            this.mostraResumoInscricao = true;
            this.$set(this.pagamento, 'idLancamento', retorno.id);
            this.idInscricaoCript = retorno.idCript;
          })
          .then(this.enviarArquivos)
          .then(() => acessosServico.arquivos(this.idInscricaoCript, this.utilizarArquivamento))
          .then(arquivos => {
            this.arquivos = arquivos;

            if (this.$refs.acessosInscricaoArquivos)
              this.$refs.acessosInscricaoArquivos.limparArquivos();
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, `${this.labelsErroSalvar} ${this.tituloInscricao}.`);
          });
        },
        setarEnderecoCadastroSimplificado() { 
            if (this.cadastroCompleto) return;

            this.inscricao.endereco = this.configuracao.enderecoFundacao;
            this.inscricao.numero = "s/n";
            this.inscricao.bairro = this.configuracao.bairroFundacao;
            this.inscricao.cidade = this.configuracao.cidadeFundacao;
            this.inscricao.uf = this.configuracao.estadoFundacao;
            this.inscricao.cep = this.configuracao.cepFundacao;
        },
      salvar() {
        $('#salvar').button('loading');

        this.setarEnderecoCadastroSimplificado();

        switch (this.tipoDocumento) {
          case "CPF":
            this.inscricao.tipo = 1;
            this.salvarInscricaoPessoa();
            break;
          case "CNPJ":
            this.inscricao.tipo = 2;
            this.salvarInscricaoPessoa();
            break;
          case "Passaporte":
            this.inscricao.tipo = 3;
            this.salvarInscricaoPessoaEstrangeira();
            break;
          default:
            $('#salvar').button('reset');
            this.$swal("", `${this.labelsErroSalvar} ${this.tituloInscricao}.`, "error");
            break;
        }
      },
      obterBandeira() {
        return new Promise((resolve, reject) => {
          PagSeguroDirectPayment.getBrand({
            cardBin: this.pagamento.numeroCartao,
            success: function (response) {
              resolve(response.brand.name);
            },
            error: function (error) {
              reject(error)
            },
          });
        });
      },
      obterTokenCartaoCredito() {
        return new Promise((resolve, reject) => {
          let mesExpiracao = this.pagamento.vencimentoCartao.split('/')[0];
          let anoExpiracao = this.pagamento.vencimentoCartao.split('/')[1];

          PagSeguroDirectPayment.createCardToken({
            cardNumber: this.pagamento.numeroCartao,
            brand: this.pagamento.bandeira,
            cvv: this.pagamento.cvv,
            expirationMonth: mesExpiracao,
            expirationYear: anoExpiracao,
            success: function (response) {
              resolve(response.card.token);
            },
            error: function (error) {
              reject(error)
            },
          });
        });
      },
      obterHashComprador() {
        return new Promise((resolve, reject) => {
          PagSeguroDirectPayment.onSenderHashReady(function (response) {
            if (response.status == 'error') {
              reject(response.message);
            }

            resolve(response.senderHash);
          });
        });
      },
      resetarClasseBotao() {
        var els = document.querySelectorAll('.meioPagamento');

        for (var i = 0; i < els.length; i++) {
          els[i].className = "btn btn-light meioPagamento";
        }
      },
      pagarBoleto() {
        var btnBoleto = document.getElementById("pagarBoleto");
        btnBoleto.setAttribute('class', "btn btn-primary meioPagamento");

        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        $('#pagarBoleto').button('loading');

        var btnBoleto = document.getElementById("pagarBoleto");
        btnBoleto.setAttribute('class', "btn btn-primary meioPagamento");

        return acessosServico
          .boleto(this.idInscricaoCript)
          .then(retorno => {
            $('#pagarBoleto').button('reset');

            let pagina = window.open('about:blank');

            if (pagina.document != null) {
              pagina.document.write(`${retorno.replace('Boleto.Net', 'Boleto Manager')}`);
              pagina.document.getElementsByClassName('w150 cn8 Al Ab')[0].remove();
              pagina.stop();
            }
            else {
              throw new (this.labelsProblemaBoletoPopUp);
            }
          })
          .catch(error => {
            $('#pagarBoleto').button('reset');

            var msg = error.bodyText
            if (error.bodyText == undefined)
              msg = this.labelsProblemaBoletoPopUp

            this.$mensagemErro(error, msg);
          });
      },
      pagarCartao() {
        this.resetarClasseBotao();
        this.mostrarCartao = true;
        this.mostrarMeioPagamento = false;

        var btnCartao = document.getElementById("pagarCartao");
        btnCartao.setAttribute('class', "btn btn-primary meioPagamento");
      },
      pagarMeioPagamento(tipo) {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = true;

        var btnMeioPagamento = document.getElementById(`pagarMeioPagamento${tipo}`);
        btnMeioPagamento.setAttribute('class', "btn btn-primary meioPagamento"); 

        switch (tipo) {
          case 1: this.meioPagamentoDescricao = this.meioPagamento1Descricao;
            break;
          case 2: this.meioPagamentoDescricao = this.meioPagamento2Descricao;
            break;
          case 3: this.meioPagamentoDescricao = this.meioPagamento3Descricao;
            break;
          case 4: this.meioPagamentoDescricao = this.meioPagamentoEstrangeiro1Descricao;
            break;
          case 5: this.meioPagamentoDescricao = this.meioPagamentoEstrangeiro2Descricao;
            break;
          case 6: this.meioPagamentoDescricao = this.meioPagamentoEstrangeiro3Descricao;
            break;
          default:
            this.meioPagamentoDescricao = '';
        }
      },
      pagar() {
        $('#pagar').button('loading');

        this.$refs.resumoInscricaoCartao
          .validar()
          .then(valido => {
            if (!valido) {
              $('#pagar').button('reset');
              throw new Error("validacao");
            }

            return valido;
          })
          .then(valido => {
            if (!valido)
              return;

            $('#ModalPlataformasPgto').modal('show');

            pagamentoServico
              .sessiao()
              .then(id => {
                PagSeguroDirectPayment.setSessionId(id);
              })
              .then(() => this.obterHashComprador())
              .then(hash => {
                this.pagamento.hash = hash;
              })
              .then(() => this.obterBandeira())
              .then(bandeira => {
                this.pagamento.bandeira = bandeira;
              })
              .then(() => this.obterTokenCartaoCredito())
              .then(token => {
                this.pagamento.token = token;
              })
              .then(() => pagamentoServico.pagar(this.pagamento))
              .then(() => {
                $('#pagar').button('reset');
                $('#ModalPlataformasPgto').modal('hide');

                this.mostraDivMeioPagamento = false;
                this.mostraMensagemPagamentoPagSeguro = true;

                this.$swal("", this.labelsPagamentoRecebidoPagSeguro, "success");
              })
              .catch(error => {
                $('#pagar').button('reset');
                $('#ModalPlataformasPgto').modal('hide');

                this.$swal(
                  this.labelsProblemaPagamentoPagSeguro,
                  error.bodyText,
                  'error'
                );
              });
          })
          .catch(erro => {
            $('#pagar').button('reset');
            this.$mensagemErro(erro, 'Erro ao válidar cartão de crédito');
            return false;
          });
      },
      pagarPagSeguroCheckout() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnPagSeguroCheckout = document.getElementById("pagarPagSeguroCheckout");
        btnPagSeguroCheckout.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarPagSeguroCheckout').button('loading');

        var btnPagSeguroCheckout = document.getElementById("pagarPagSeguroCheckout");
        btnPagSeguroCheckout.setAttribute('class', "btn btn-primary meioPagamento");

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCheckout(this.pagamento)
          .then(retorno => {
            $('#pagarPagSeguroCheckout').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagarPagSeguroCheckout').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsProblemaPagamentoPagSeguro,
              error.bodyText,
              'error'
            );
          });
      },
      pagarBoletoGetNet() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnBoletoGetNet = document.getElementById("pagarBoletoGetNet");
        btnBoletoGetNet.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarBoletoGetNet').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarBoletoGetNet(this.pagamento)
          .then(retorno => {
            $('#pagarBoletoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagarBoletoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsProblemaGetNetBoleto,
              error.bodyText,
              'error'
            );
          });
      },
      pagarCreditoGetNet() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnCreditoGetNet = document.getElementById("pagarCreditoGetNet");
        btnCreditoGetNet.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarCreditoGetNet').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(this.pagamento)
          .then(retorno => {
            $('#pagarCreditoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagarCreditoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsProblemaGetNetCredito,
              error.bodyText,
              'error'
            );
          });
      },
      pagarDebitoGetNet() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnDebitoGetNet = document.getElementById("pagarDebitoGetNet");
        btnDebitoGetNet.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarDebitoGetNet').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarDebitoGetNet(this.pagamento)
          .then(retorno => {
            $('#pagarDebitoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagarDebitoGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsProblemaGetNetDebito,
              error.bodyText,
              'error'
            );
          });
      },
      pagarPix() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnPix = document.getElementById("pagaPix");
        btnPix.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagaPix').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarPix(this.pagamento)
          .then(retorno => {
            
            $('#ModalPlataformasPgto').modal('hide');
    
            var qrcodePix = JSON.parse(retorno.bodyText);
            this.copiaColaPix = qrcodePix.QrCode.url;
            this.imgQRCodePix = 'data:image/jpeg;base64,' + qrcodePix.QrCode.imagem;
            this.mostraMensagemPagamentoPix = true;

            this.startTimerPix();
          })
          .catch(error => {
            $('#pagaPix').button('reset');
            $('#ModalPlataformasPgto').modal('hide');
            this.mostraMensagemPagamentoPix = false;

            this.$swal(
              this.labelsProblemaPagamentoPIX,
              error.bodyText,
              'error'
            );
          });
      },
      santander() {
        pagamentoServico
          .santander()
          .then(retorno => {
            
          })
          .catch(error => {
           this.$swal(
              this.labelsProblemaGetNetDebito,
              error.bodyText,
              'error'
            );
          });
      },
      pagarCreditoIntGetNet() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnCreditoIntGetNet = document.getElementById("pagarCreditoIntGetNet");
        btnCreditoIntGetNet.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarCreditoIntGetNet').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(this.pagamento)
          .then(retorno => {
            $('#pagarCreditoIntGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url);
          })
          .catch(error => {
            $('#pagarCreditoIntGetNet').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsErroGetNetInternacional,
              error.bodyText,
              'error'
            );
          });
      },
      pagarPayPalEstrangeiro() {
        this.resetarClasseBotao();
        this.mostrarCartao = false;
        this.mostrarMeioPagamento = false;

        var btnPayPalEstrangeiro = document.getElementById("pagarPayPalEstrangeiro");
        btnPayPalEstrangeiro.setAttribute('class', "btn btn-primary meioPagamento");

        $('#pagarPayPalEstrangeiro').button('loading');

        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarPayPal(this.pagamento)
          .then(retorno => {
            $('#pagarPayPalEstrangeiro').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;
            window.open(url, '_self');
          })
          .catch(error => {
            $('#pagarPayPalEstrangeiro').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.$swal(
              this.labelsErroPayPalEstrangeiro,
              error.bodyText,
              'error'
            );
          });
      },
      enviarArquivos() {
        var copiaArquivos = null;

        if (this.$refs.acessosInscricaoArquivos) {
            copiaArquivos = this.$refs.acessosInscricaoArquivos.arquivosInterno
        }

        if (copiaArquivos) {
            copiaArquivos = converterObjetoFormData(copiaArquivos);

            return Vue.http.post(`/api/acessos/${this.idInscricaoCript}/inscricao/arquivos`, copiaArquivos);
        }

        return true;
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaInscricao = JSON.parse(JSON.stringify(this.inscricao));

        if (this.mostraResumoInscricao)
          return acessosServico.alterar(copiaInscricao, this.idInscricaoCript);
        else
          return acessosServico.adicionar(copiaInscricao);
      },
      abrirURLRedirecionamento() {
        window.open(this.urlDirecionamento, "_blank");
      },
      mostrarMensagemPago() {
        if (this.mostraResumoInscricao == false)
          return false;

        if (!this.inscricao.lancamentoInscricoes)
          return false;

        if (!this.inscricao.lancamentoInscricoes[0].lancamento)
          return false;

        if (this.inscricao.lancamentoInscricoes[0].lancamento.data > 0) {
          this.mostraDivMeioPagamento = false;
          this.mostrarMensagemPagoStatus = 1;
          return true;
        }

        // PayPall
        if (this.inscricao.lancamentoInscricoes[0].lancamento.payPalStatus){
            // Não aprovada
            if (this.inscricao.lancamentoInscricoes[0].lancamento.payPalStatus == 'VOIDED') {
              this.mostraDivMeioPagamento = true;
              this.mostrarMensagemPagoStatus = 3;
              return true;
            }

            // Aguardando
            if (this.inscricao.lancamentoInscricoes[0].lancamento.payPalStatus != 'VOIDED') {
              this.mostraDivMeioPagamento = false;
              this.mostrarMensagemPagoStatus = 2;
              return true;
            }
        }

        if (!this.inscricao.lancamentoInscricoes[0].lancamento.data)
          return false;

        return false;
      },
      retornaData(data) {
        if (!data)
          return '';

        return formatarData.paraData(data);
      },
      download(arquivo) {
        acessosServico
          .download(this.idInscricaoCript, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      setaQuantidadeArquivos(quantidade) {
        if (!this.$refs.acessosInscricaoArquivos)
          return true;
        
        this.$refs.acessosInscricaoArquivos.setaQuantidadeArquivos(quantidade)
      },
    },
    computed: {
      labelCopiaColaPIX() {
        return this.labelsLinguagemSelecionada.labels.copiaColaPIX
      },
      labelsInscricao(){
          return this.labelsLinguagemSelecionada.labels.inscricao
      },
      labelsDoacao(){
        return this.labelsLinguagemSelecionada.labels.doacao
      },
      labelsTituloSiteDoacao() {
        return this.labelsLinguagemSelecionada.labels.tituloSiteDoacao;
      },
      labelsTituloSiteCurso() {
          return this.labelsLinguagemSelecionada.labels.tituloSiteCurso;
      },
      labelsTituloSiteEvento() {
          return this.labelsLinguagemSelecionada.labels.tituloSiteEvento;
      },
      labelsPerguntasObrigatorias(){
        return this.labelsLinguagemSelecionada.labels.perguntasObrigatorias;
      },
      labelsAnexarPeloMenosUmArquivo(){
          return this.labelsLinguagemSelecionada.labels.anexarPeloMenosUmArquivo;
      },
      labelsSalvaSucesso(){
          return this.labelsLinguagemSelecionada.labels.salvaSucesso;
      },
      labelsErroSalvar(){
          return this.labelsLinguagemSelecionada.labels.erroSalvar;
      },
      labelsProblemaBoletoPopUp() {
        return this.labelsLinguagemSelecionada.labels.problemaBoletoPopUp;
      },
      labelsProblemaPagamentoPIX() {
        return this.labelsLinguagemSelecionada.labels.problemaPagamentoPIX;
      },
      labelsProblemaGetNetDebito() {
        return this.labelsLinguagemSelecionada.labels.problemaGetNetDebito;
      },
      labelsProblemaGetNetCredito() {
        return this.labelsLinguagemSelecionada.labels.problemaGetNetCredito;
      },
      labelsProblemaGetNetBoleto() {
        return this.labelsLinguagemSelecionada.labels.problemaGetNetBoleto;
      },
      labelsProblemaPagamentoPagSeguro() {
        return this.labelsLinguagemSelecionada.labels.problemaPagamentoPagSeguro;
      },
      labelsPagamentoRecebidoPagSeguro() {
        return this.labelsLinguagemSelecionada.labels.pagamentoRecebidoPagSeguro;
      },
      labelsErroGetNetInternacional(){
          return this.labelsLinguagemSelecionada.labels.erroGetNetInternacional;
      },
      labelsErroPayPalEstrangeiro(){
          return this.labelsLinguagemSelecionada.labels.erroPayPalEstrangeiro;
      },
      labelsErroCamposObrigatorios(){
        return this.labelsLinguagemSelecionada.labels.erroCamposObrigatorios;
      },
      labelsValorEntre(){
        return this.labelsLinguagemSelecionada.labels.valorEntre;
      },
      labelsValorMaiorIgual(){
        return this.labelsLinguagemSelecionada.labels.valorMaiorIgual;
      },
      labelsValorMenorIgual(){
        return this.labelsLinguagemSelecionada.labels.valorMenorIgual;
      },
      labelsNecessarioAnexarPeloMenos(){
        return this.labelsLinguagemSelecionada.labels.necessarioAnexarPeloMenos;
      },
      labelsPermitidoAnexarMax(){
        return this.labelsLinguagemSelecionada.labels.permitidoAnexarMax;
      },
      labelsArquivos(){
        return this.labelsLinguagemSelecionada.labels.arquivos;
      },
      labelsPagamentoProcessandoPayPal(){
        return this.labelsLinguagemSelecionada.labels.pagamentoProcessandoPayPal;
      },
      labelsPagamentoReijeitadoPayPal(){
        return this.labelsLinguagemSelecionada.labels.pagamentoReijeitadoPayPal;
      },

      existeurlDirecionamento() {
        if (!this.urlDirecionamento)
          return false;

        return this.urlDirecionamento.includes(".");
      },
      utilizarArquivamento() {
        return this.configuracao.usarArquivosInscricao && this.utilizarArquivo && this.inscricao.utilizarArquivo && !this.inscricao.arquivosAprovados;
      },
      utilizarArquivamentoEdicao() {
        return this.configuracao.usarArquivosInscricao && this.utilizarArquivo && this.inscricao.utilizarArquivo;
      }
    },
    mounted() {     
      let pagseguro = document.createElement('script');
      ///pagseguro.setAttribute('src', 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js');
      pagseguro.setAttribute('src', 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js');
      document.head.appendChild(pagseguro);

      if (this.$route.params.linguagemSelecionada) {
        this.setarLinguagemSelecionada(this.$route.params.linguagemSelecionada);  
        
        if (this.$route.params.linguagemSelecionada != 'pt-Br') {
            this.tipoDocumento = 'Passaporte';   
        }
      }
    },
    created() {
      this.mostraLinguagens();
      this.setarLinguagemSelecionada(this.linguagemSelecionada);
      this.configuraTipo(false);
      this.setaCadastroCompleto();
      this.setaMeiosPagamento();

      if (this.acessoObjeto.doacao) {
        this.acessoObjeto.descricao = this.acessoObjeto.doacao.descricao;
        this.acessoObjeto.resumo = this.acessoObjeto.doacao.resumo;
      }

      if (this.idInscricaoDiretaCript) {
        this.buscarBeneficiario();
      }
    },
    watch: {
      'tipoDocumento': 'limparDocumento'
    }
  }
</script>

<template>
  <div>
    <div>
      <!-- Modal -->
      <div class="modal fade" id="ModalPlataformasPgto" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <p>
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span style="font-size: 16px;margin-left: 10px;">{{ this.labelsLinguagemSelecionada.labels.contatoProvedor }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <article class="well listing-item">
        <div class="media-left listing-item__logo">
          <img class="media-object profile__img-company" :src="imagemCover">
        </div>

        <div class="media-body-local">
          <div class="media-heading listing-item__title">
            {{ labelsDadosLinguagemSelecionada.descricao }}
          </div>
          <div class="listing-item__desc">
            {{ labelsDadosLinguagemSelecionada.resumo }}
          </div>
        </div>

        <div class="row" v-if="linguagensDisponiveis.length > 1" style="text-align: center;">
           <label class="control-label">{{ this.labelsLinguagemSelecionada.labels.escolhaIdioma }}</label>
           <div class="col-sm-12">
              <table class="table" style="width: auto;margin-bottom: 0px;" align='center'>
                  <tbody>
                      <tr>
                          <td style="text-align: center;width: 64px;" v-for="lingua in linguagensDisponiveis">
                              <a @click="setarLinguagemSelecionada(lingua.simbolo)">
                                  <img :src="lingua.imagem" :alt="lingua.simbolo" style="width:64px;height:64px;" :v-tooltip="lingua.simbolo"
                                       :class="{'LinguagemNaoSelecionada': linguagemSelecionada != lingua.simbolo}">
                              </a>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>

        <div class="hr-line-dashed margin-top-20"></div>

        <form @submit.prevent="validarBeneficiario">

          <div class="tabs-container" v-if="mostrarFormulario">
            <dados-pf-pj ref="dadosPfPj"
                         :inscricao="inscricao"
                         :cadastroCompleto="cadastroCompleto"
                         :doacao="acessoObjeto.doacao"
                         :turma="acessoObjeto.turma"
                         :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                         @setaQuantidadeArquivos="setaQuantidadeArquivos"
                         v-if="((tipoDocumento == 'CPF') || (tipoDocumento == 'CNPJ'))">
            </dados-pf-pj>

            <dados-estrangeiro ref="dadosEstrangeiro"
                               :inscricao="inscricao"
                               :cadastroCompleto="cadastroCompleto"
                               :doacao="acessoObjeto.doacao"
                               :turma="acessoObjeto.turma"
                               :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                               @setaQuantidadeArquivos="setaQuantidadeArquivos"
                               v-if="(tipoDocumento == 'Passaporte')">
            </dados-estrangeiro>

            <acessos-inscricao-arquivos ref="acessosInscricaoArquivos"
                                        v-if="utilizarArquivamento"
                                        :arquivos="arquivos"
                                        :inscricao="inscricao"
                                        :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                                        @download="download">
            </acessos-inscricao-arquivos>
          </div>

          <div class="tabs-container" v-if="mostraResumoInscricao">
            <resumo-inscricao ref="resumoInscricao"
                              :inscricao="inscricao"
                              :idCript="idCript"
                              :cadastroCompleto="cadastroCompleto"
                              v-if="!estrangeiro"
                              :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                              :rotaAnterior="rotaAnterior">
            </resumo-inscricao>

            <resumo-inscricao-estrangeiro ref="resumoInscricao"
                                          :inscricao="inscricao"
                                          :idCript="idCript"
                                          :cadastroCompleto="cadastroCompleto"
                                          v-if="estrangeiro"
                                          :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                                          :rotaAnterior="rotaAnterior">
            </resumo-inscricao-estrangeiro>

            <div id="divMeiosPagamento" v-if="mostraDivMeioPagamento && (inscricao.valor > 0)">
              <div class="row">
                  <div class="col-sm-12" style="display:flex; justify-content: center;">
                      <button id="pagarBoleto"
                              v-if="mostrarMeioPagamentoBoleto && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarBoleto"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                          <i class="fa fa-barcode"></i>
                          Boleto
                      </button>

                      <button id="pagarCartao"
                              v-if="mostrarMeioPagamentoCartao && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarCartao"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          Cartão de crédito
                      </button>

                      <button id="pagarPagSeguroCheckout"
                              v-if="mostrarPagSeguroCheckout && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarPagSeguroCheckout"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          PagSeguro
                      </button>

                      <button id="pagarBoletoGetNet"
                              v-if="mostrarMeioPagamentoBoletoGetNet && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarBoletoGetNet"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          Boleto GetNet
                      </button>

                      <button id="pagarCreditoGetNet"
                              v-if="mostrarMeioPagamentoCreditoGetNet && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarCreditoGetNet"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          Crédito GetNet
                      </button>

                      <button id="pagarDebitoGetNet"
                              v-if="mostrarMeioPagamentoDebitoGetNet && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarDebitoGetNet"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          Débito GetNet
                      </button>

                      <button id="pagarCreditoIntGetNet"
                              v-if="mostrarMeioPagamentoCreditoIntGetNet && estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarCreditoIntGetNet"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          Crédito GetNet
                      </button>

                      <button id="pagarPayPalEstrangeiro"
                              v-if="mostrarMeioPagamentoPayPalEstrangeiro && estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarPayPalEstrangeiro"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-credit-card"></i>
                          PayPal
                      </button>

                      <button id="pagaPix"
                              v-if="mostrarMeioPagamentoPix && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarPix"
                              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                          <i class="fa fa-qrcode"></i>
                          Pix
                      </button>

                      <button id="pagarMeioPagamento1"
                              v-if="mostrarMeioPagamento1 && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(1)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamento1Titulo }}
                      </button>

                      <button id="pagarMeioPagamento2"
                              v-if="mostrarMeioPagamento2 && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(2)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamento2Titulo }}
                      </button>

                      <button id="pagarMeioPagamento3"
                              v-if="mostrarMeioPagamento3 && !estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(3)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamento3Titulo }}
                      </button>

                      <button id="pagarMeioPagamento4"
                              v-if="mostrarMeioPagamentoEstrangeiro1 && estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(4)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamentoEstrangeiro1Titulo }}
                      </button>

                      <button id="pagarMeioPagamento5"
                              v-if="mostrarMeioPagamentoEstrangeiro2 && estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(5)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamentoEstrangeiro2Titulo }}
                      </button>

                      <button id="pagarMeioPagamento6"
                              v-if="mostrarMeioPagamentoEstrangeiro3 && estrangeiro"
                              type="button"
                              class="btn btn-light meioPagamento"
                              @click="pagarMeioPagamento(6)">
                          <i class="fa fa-money"></i>
                          {{ meioPagamentoEstrangeiro3Titulo }}
                      </button>
                  </div>
              </div>

              <div class="hr-line-dashed margin-top-20" v-if="mostrarCartao"></div>

              <div class="row" v-if="mostrarCartao">
                <div class="col-sm-12">
                  <resumo-inscricao-cartao ref="resumoInscricaoCartao"
                                           :pagamento="pagamento">
                  </resumo-inscricao-cartao>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <button id="pagar"
                          type="button"
                          class="btn btn-primary"
                          style="float: right;"
                          @click="pagar"
                          v-show="mostrarCartao"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Pagando...">
                    <i class="fa fa-cc"></i>
                    {{ this.labelsLinguagemSelecionada.labels.pagar }}
                  </button>
                </div>
              </div>

              <div class="hr-line-dashed margin-top-20" v-if="mostrarMeioPagamento"></div>

              <div class="row" v-if="mostrarMeioPagamento">
                <dl class="col-xs-12">
                  <dd v-html="nl2br(meioPagamentoDescricao)">
                    {{ nl2br(meioPagamentoDescricao) }}
                  </dd>
                </dl>
              </div>

              <div class="hr-line-dashed margin-top-20"></div>
            </div>

            <div v-if="mostraMensagemPagamentoPagSeguro" id="mensagemPagamentoPagSeguro">
              <p class="PagamentoAlerta">
                <i class="fa fa-check-circle" style="color:green;"></i>
                <span style="font-size: 16px;margin-left: 10px;">{{ this.labelsPagamentoRecebidoPagSeguro }}</span>
              </p>

              <div class="hr-line-dashed margin-top-20"></div>
            </div>


            <div v-if="mostrarMensagemPago()" id="mensagemPagamentoPago">
                <p class="PagamentoAlerta" v-if="mostrarMensagemPagoStatus == 1">
                    <i class="fa fa-check-circle" style="color:green;"></i>
                    <span style="font-size: 16px;margin-left: 10px;">{{ this.labelsLinguagemSelecionada.labels.pagamentoRecebidoDia }} {{ retornaData(this.inscricao.lancamentoInscricoes[0].lancamento.data) }}</span>
                </p>

                <p class="PagamentoAlerta" v-if="mostrarMensagemPagoStatus == 2">
                    <i class="fa fa-hourglass-start" style="color:#9b9f02;"></i>
                    <span style="font-size: 16px;margin-left: 10px;">{{ this.labelsPagamentoProcessandoPayPal }}</span>
                </p>

                <p class="PagamentoAlerta" v-if="mostrarMensagemPagoStatus == 3">
                    <i class="fa fa-ban" style="color:#d72323;"></i>
                    <span style="font-size: 16px;margin-left: 10px;">{{ this.labelsPagamentoReijeitadoPayPal }}</span>
                </p>

                <div class="hr-line-dashed margin-top-20"></div>
            </div>

            <div v-if="mostraMensagemPagamentoPix" id="mensagemPagamentoPix">
              <div class="row">
                <div class="col-sm-10" style="padding-right: 3px;">
                  <div class="form-group">
                    <input id="copiaColaPix"
                           class="form-control"
                           type="text"
                           v-model="copiaColaPix"
                           readonly="readonly"
                           data-vv-name="copiaColaPix"
                           enabled="false">
                  </div>
                </div>
                <div class="col-sm-2" style="padding-left: 0px;">
                  <button id="copiaColaPixButton"
                          type="button"
                          class="btn btn-primary"
                          @click="copiarCopiaColaPix">
                    <i class="fa fa-copy"></i>
                    Copiar
                  </button>
                </div>
              </div>

              <img style='width: 250px; height: 250px; display: flex; margin: 0 auto; ' id='qrcodepix'
                   :src='this.imgQRCodePix' />

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group" style='display: flex; margin: 0 auto;'>
                    <span id="tempo-pix">00:05:00</span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed margin-top-20"></div>
            </div>

            <acessos-inscricao-arquivos ref="acessosInscricaoArquivos"
                                        v-if="utilizarArquivamentoEdicao"
                                        :arquivos="arquivos"
                                        :inscricao="inscricao"
                                        :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada"
                                        @download="download">
            </acessos-inscricao-arquivos>

            <div class="row" v-if="mostraResumoInscricao">
              <div class="col-sm-12">
                <div class="form-group">
                    <router-link class="btn btn-primary"
                                 :to="{ name: rotaAnterior, params: { id: idCript } }"
                                 active-class="">
                        <i class="fa fa-arrow-left"></i>
                        {{ this.labelsLinguagemSelecionada.labels.voltar }}
                    </router-link>

                  <button id="finalizar"
                          type="button"
                          class="btn btn-primary"
                          @click="abrirURLRedirecionamento"
                          v-show="existeurlDirecionamento"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
                    <i class="fa fa-globe"></i>
                    {{ this.labelsLinguagemSelecionada.labels.visitarSite }} {{ this.tituloSite }}
                  </button>

                  <button id="alterar"
                          type="button"
                          class="btn btn-success"
                          @click="alterar"
                          v-if="utilizarArquivamento"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                    <i class="fa fa-save"></i>
                    {{ this.labelsLinguagemSelecionada.labels.salvar }}
                  </button>
                </div>
              </div>
            </div>

          </div>

          <div class="row" v-if="!mostrarFormulario && !mostraResumoInscricao">
            <div class="col-sm-12">
              <div class="form-group radios">
                <radio v-model="tipoDocumento"
                       selected-value="CPF"
                       type="success"
                       :inline="true"
                       class="no-margin-top no-margin-bottom margin-right-10">
                  {{ this.labelsLinguagemSelecionada.labels.pessoaFisica }}
                </radio>
                <radio v-model="tipoDocumento"
                       v-if="mostrarEstrangeiro"
                       selected-value="Passaporte"
                       type="success"
                       :inline="true"
                       class="no-margin-top no-margin-bottom margin-right-10">
                  {{ this.labelsLinguagemSelecionada.labels.pessoaFisicaEstrangeira }}
                </radio>
                <radio v-model="tipoDocumento"
                       v-if="doacao"
                       selected-value="CNPJ"
                       type="success"
                       :inline="true"
                       class="no-margin-top no-margin-bottom">
                  {{ this.labelsLinguagemSelecionada.labels.pessoaJuridica }}
                </radio>
              </div>
            </div>
          </div>

          <div class="row" v-if="!mostrarFormulario && !mostraResumoInscricao">
            <div class="col-sm-12" v-if="!estrangeiro">
              <div class="form-group required" :class="{'has-error': errors.has('documento')}">
                  <label for="documento" class="control-label">{{ tipoDocumento }} {{ this.labelsLinguagemSelecionada.labels.para }} {{ tituloInscricao }}</label>

                <input type="text"
                       class="form-control"
                       id="documento"
                       v-model="documento"
                       data-vv-as="documento"
                       data-vv-name="documento"
                       v-mascara="tipoDocumento.toLocaleLowerCase()"
                       v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`">

                <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="!mostrarFormulario && !mostraResumoInscricao">
            <div class="col-sm-12" v-if="estrangeiro">
              <div class="form-group required" :class="{'has-error': errors.has('emailerro')}">
                  <label class="control-label" for="emailcampo">{{ this.labelsLinguagemSelecionada.labels.email }} {{ this.labelsLinguagemSelecionada.labels.para }} {{ tituloInscricao }}</label>

                <input type="text"
                       class="form-control"
                       id="emailcampo"
                       v-model="documento"
                       data-vv-name="emailerro"
                       data-vv-as="email"
                       v-validate="'required|email'">

                <p class="text-danger" v-show="errors.has('emailerro')">{{ this.labelsLinguagemSelecionada.labels.email }} {{ this.labelsLinguagemSelecionada.labels.obrigatorioInscricao }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <button id="avancar"
                        type="button"
                        class="btn btn-primary"
                        @click="validarBeneficiario"
                        v-show="!mostrarFormulario && !mostraResumoInscricao"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
                  {{ this.labelsLinguagemSelecionada.labels.proximo }}
                  <i class="fa fa-arrow-right"></i>
                </button>

                <button id="salvar"
                        type="button"
                        class="btn btn-primary"
                        @click="salvar"
                        v-show="mostrarFormulario"
                        data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                  <i class="fa fa-save"></i>
                  {{ this.labelsLinguagemSelecionada.labels.salvar }}
                </button>
              </div>
            </div>
          </div>

        </form>
      </article>

    </div>
  </div>
</template>

<style scoped>
  .listing-item {
    margin: 0 auto 20px;
    display: block;
    width: 85%;
  }

  .listing-item__date {
    color: rgba(62, 62, 62, 0.3);
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
    white-space: nowrap;
  }

  .listing-item__desc {
    text-overflow: ellipsis;
    margin-top: 8px;
    padding-right: 21px;
    line-height: 24px;
    margin-bottom: 6px;
    overflow: hidden;
    max-width: 700px;
    word-break: break-word;
  }

  .media-left {
    padding-right: 10px;
  }

  @media (min-width: 768px) {
    .media-body-local, .media-left {
      display: table-cell;
      vertical-align: top;
    }
  }

  @media (max-width: 768px) {

    .media-left {
      display: table-cell;
      vertical-align: top;
    }

    .media-body-local {
      margin-top: 10px;
    }
  }

  .listing-item__title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .listing-item__logo {
    vertical-align: middle;
    min-width: 150px;
    width: 150px;
    text-align: center;
    position: relative;
  }

  .listing-item__logo .media-object:not(.profile__img) {
    max-width: 125px;
    max-height: 125px;
    margin-right: 15px;
    display: inline-block;
  }

  .profile__img-company {
    border-radius: 6px;
    width: 115px;
    height: 115px;
  }

  .well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  }

  .well {
    border-radius: 6px;
  }

  .listing-item {
    min-width: 310px;
    min-height: 104px;
    background-color: #fff;
    box-shadow: none;
    -webkit-transition: box-shadow 0.2s ease-in;
    -moz-transition: box-shadow 0.2s ease-in;
    -o-transition: box-shadow 0.2s ease-in;
    transition: box-shadow 0.2s ease-in;
  }

  .meioPagamento {
    height: 60px;
    width:180px;
    margin-right:10px;
  }

  .modal {
    text-align: center;
  }

  @media screen {
    .modal:before {
      display: inline-block;
      vertical-align: middle;
      content: " ";
      height: 100%;
    }
  }

  .modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
  }

  .modal p {
    display: flex;
    align-items: center;
  }

  .PagamentoAlerta {
    font-size: 40px;
    display: flex;
    align-items: center;
    vertical-align: middle;
  }

  #tempo-pix {
    display: flex;
    margin: 0 auto;
    font-weight: bold;
    font-size: 20px;
  }

  .LinguagemNaoSelecionada {
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessosInscricaoForm.vue